/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RedeployRequestBody = {
  /**
   * The ID of the deployment to redeploy.
   */
  deploymentId: string;
};

/** @internal */
export type RedeployRequestBody$Outbound = {
  deployment_id: string;
};

/** @internal */
export const RedeployRequestBody$outboundSchema: z.ZodMiniType<
  RedeployRequestBody$Outbound,
  RedeployRequestBody
> = z.pipe(
  z.object({
    deploymentId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
    });
  }),
);

export function redeployRequestBodyToJSON(
  redeployRequestBody: RedeployRequestBody,
): string {
  return JSON.stringify(
    RedeployRequestBody$outboundSchema.parse(redeployRequestBody),
  );
}
